module.exports = __webpack_public_path__ + "static/media/3.603f94bd.jpg";